// extracted by mini-css-extract-plugin
export default {"link":"iF-z","disabled":"jF-z"};